import { gql } from 'apollo-angular';

export const GET_ALL_OFFERS = gql`
  query ProductOfferFindAll(
    $skip: Int
    $take: Int
    $where: ProductOfferWhereInput
    $orderBy: [ProductOfferOrderByWithRelationAndSearchRelevanceInput!]
  ) {
    ProductOfferFindAll(
      skip: $skip
      take: $take
      where: $where
      orderBy: $orderBy
    ) {
      data {
        id
        inconTermId
        InconTerm {
          id
          name
        }
        isCorrupted
        length
        number
        obs
        originPort {
          id
          name
          countryId
          country {
            id
            name
          }
        }
        originPortId
        productOfferState {
          id
          name
        }
        productStateId
        qualityType {
          id
          name
        }
        quantity {
          id
          quantity
          quantityType {
            id
            name
          }
        }
        qualityTypeId
        quantityId
        sawnType {
          id
          name
        }
        sawnTypeId
        shipment {
          id
          name
          usesContainers
        }
        shipmentId
        specy {
          id
          name
        }
        supplier {
          id
          name
          externalCode
        }
        thick
        via
        width
        corruptedObs
        date
        dryType {
          id
          name
        }
        fsc
        supplierType
        profitMargin
        salePrice
        woodTotal
        volumeM3
        requestedVolumeM3
        idleCapacityM3
        capacityMissing
        containers {
          id
          quantityTypeId
          count
          capacityM3
          exceedsPhysicalVolume
          capacityMissing
          subtotalM3
          quantityType {
            id
            name
            quantityInM3
          }
        }
        Pricings {
          id
          isMainCurrency
          value
          currency {
            id
            name
          }
        }
      }
      total
    }
  }
`;

export const GET_OFFER_BY_ID = gql`
  query ProductOfferFindOne($where: ProductOfferWhereUniqueInput!) {
    ProductOfferFindOne(where: $where) {
      id
      inconTermId
      isCorrupted
      length
      number
      obs
      originPort {
        id
        name
      }
      originPortId
      productOfferState {
        id
        name
      }
      productStateId
      profitMargin
      salePrice
      bulkPrice
      woodTotal
      volumeM3
      requestedVolumeM3
      idleCapacityM3
      capacityMissing
      containers {
        id
        quantityTypeId
        count
        capacityM3
        exceedsPhysicalVolume
        capacityMissing
        subtotalM3
        quantityType {
          id
          name
          quantityInM3
        }
      }
      qualityType {
        id
        name
      }
      qualityTypeId
      quantity {
        id
        quantity
        quantityType {
          id
          name
          quantityInM3
        }
        calculatedQuantity
      }
      sawnType {
        id
        name
      }
      shipment {
        id
        name
        usesContainers
      }
      specy {
        id
        name
      }
      supplier {
        id
        name
        externalCode
      }
      thick
      via
      width
      InconTerm {
        id
        name
      }
      Pricings {
        id
        isMainCurrency
        value
        currency {
          id
          name
        }
      }
      corruptedObs
      date
      dryType {
        id
        name
      }
      sawnTypeId
      shipmentId
      specyId
      supplierId
      quantityId
      dryTypeId
      fsc
      supplierType
    }
  }
`;

export const ADD_OFFER = gql`
  mutation ProductOfferCreate($data: ProductOfferCreateInput!) {
    ProductOfferCreate(data: $data) {
      id
    }
  }
`;

export const UP_OFFER = gql`
  mutation ProductOfferUpdate(
    $data: ProductOfferUpdateInput!
    $where: ProductOfferWhereUniqueInput!
  ) {
    ProductOfferUpdate(data: $data, where: $where) {
      id
    }
  }
`;

export const ADD_QUANTITY = gql`
  mutation QuantityCreate($data: QuantityCreateInput!) {
    QuantityCreate(data: $data) {
      id
    }
  }
`;

export const DELETE_OFFER_MUTATION = gql`
  mutation ProductOfferDelete($where: ProductOfferWhereUniqueInput!) {
    ProductOfferDelete(where: $where) {
      id
    }
  }
`;

export const GET_OFFER_CALCULATION_TRACE = gql`
  query ProductOfferCalculationTrace($offerId: Int!) {
    ProductOfferCalculationTrace(offerId: $offerId) {
      subject
      currency
      steps {
        key
        label
        formula
        substituted
        inputs {
          name
          value
          number
          source
        }
        result
        resultNumber
        unit
        note
      }
    }
  }
`;
